import React, {memo, useContext} from 'react'
import {HotelCardContext} from 'components/HotelCardContext'
import {useGetHotelAvailabilityForCurrentSearch} from 'hooks/useGetHotelAvailabilityForCurrentSearch'
import {useOtaMode} from 'hooks/useOtaMode'
import {SelectedElement} from 'utils/selectedElement'

import {Box} from '@vio/atlas/helpers/Box'

import {ComposedHotelCard} from './ComposedHotelCard/ComposedHotelCard'
import {ExperimentalBoVioFirstCard} from './ExperimentalBoVioFirstCard'

export const HOTEL_CARD_MAX_WIDTH = 587

interface Props {
  isPriorityCard: boolean
}

const HotelCardMobileComponent = ({isPriorityCard}: Props) => {
  const {isAnchor, hotelId} = useContext(HotelCardContext)
  useGetHotelAvailabilityForCurrentSearch({isAnchor, hotelId})

  const {isBoVioEnvironment} = useOtaMode()

  if (isBoVioEnvironment) {
    return (
      <Box
        data-id={isAnchor ? 'anchorHotel' : 'nonAnchorHotel'}
        maxWidth={`${HOTEL_CARD_MAX_WIDTH}px`}
        margin="0 auto"
        paddingBottom="s500"
      >
        <div data-id={SelectedElement.BlankSpace}>
          <ExperimentalBoVioFirstCard isPriorityCard={isPriorityCard} />
        </div>
      </Box>
    )
  }

  return (
    <Box
      data-id={isAnchor ? 'anchorHotel' : 'nonAnchorHotel'}
      maxWidth={`${HOTEL_CARD_MAX_WIDTH}px`}
      margin="0 auto"
      paddingBottom="s500"
    >
      <div data-id={SelectedElement.BlankSpace}>
        <ComposedHotelCard isPriorityCard={isPriorityCard} />
      </div>
    </Box>
  )
}

export const HotelCardMobile = memo(HotelCardMobileComponent)
